(function () {
  'use strict';

  function initCarousel(root) {
    var track = root.querySelector('.mc-collection-grid-section .mc-grid-3');
    var prevBtn = root.querySelector('.mc-collection-grid__arrow--prev');
    var nextBtn = root.querySelector('.mc-collection-grid__arrow--next');
    if (!track) return;

    function pageAmount() {
      var item = track.querySelector('.mc-collection-card');
      if (!item) return track.clientWidth;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || 0);
      return item.getBoundingClientRect().width + gap;
    }

    function updateArrowState() {
      if (!prevBtn || !nextBtn) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -pageAmount(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: pageAmount(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateArrowState, { passive: true });
    window.addEventListener('resize', updateArrowState);
    updateArrowState();

    var isPointerDown = false;
    var didDrag = false;
    var startX = 0;
    var startScroll = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      isPointerDown = true;
      didDrag = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
    });

    track.addEventListener('pointermove', function (e) {
      if (!isPointerDown) return;
      var delta = e.clientX - startX;
      if (Math.abs(delta) > 4) didDrag = true;
      track.scrollLeft = startScroll - delta;
    });

    function endDrag() {
      if (!isPointerDown) return;
      isPointerDown = false;
      track.classList.remove('is-dragging');
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointerleave', endDrag);
    track.addEventListener('pointercancel', endDrag);

    track.addEventListener(
      'click',
      function (e) {
        if (didDrag) {
          e.preventDefault();
          e.stopPropagation();
          didDrag = false;
        }
      },
      true
    );

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        track.scrollBy({ left: pageAmount(), behavior: 'smooth' });
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        track.scrollBy({ left: -pageAmount(), behavior: 'smooth' });
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.mc-collection-grid-section').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var el = event.target.querySelector('.mc-collection-grid-section');
    if (el) initCarousel(el);
  });
})();
